import React from 'react';
import PropTypes from 'prop-types';

class Header extends React.Component {
	static propTypes = {
		headers: PropTypes.object.isRequired,
	}

	render() {
		const { headers } = this.props;

		return (
			<div>
				{Object.keys(headers).map((headerName, index) => {
					const header = headers[headerName];
					return (
						<div key={index} className="notes">
							{header.isRequired &&
								<span className="required-header">Required Header: </span>
							}
							<span>{`${header.header} - ${header.notes}`}</span>
						</div>

					);
				})}
			</div>
		);
	}
}

export default Header;


// WEBPACK FOOTER //
// ./src/components/api/Header.js